import { render, staticRenderFns } from "./bannerAddPage.vue?vue&type=template&id=1e5077b6&scoped=true&"
import script from "./bannerAddPage.vue?vue&type=script&lang=js&"
export * from "./bannerAddPage.vue?vue&type=script&lang=js&"
import style0 from "./bannerAddPage.vue?vue&type=style&index=0&id=1e5077b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5077b6",
  null
  
)

export default component.exports